"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countries = void 0;
exports.countries = [
    'AND',
    'ARE',
    'AFG',
    'ATG',
    'AIA',
    'ALB',
    'ARM',
    'ANT',
    'AGO',
    'ATA',
    'ARG',
    'ASM',
    'AUT',
    'AUS',
    'ABW',
    'ALA',
    'AZE',
    'BIH',
    'BRB',
    'BGD',
    'BEL',
    'BFA',
    'BGR',
    'BHR',
    'BDI',
    'BEN',
    'BMU',
    'BRN',
    'BOL',
    'BRA',
    'BHS',
    'BTN',
    'BVT',
    'BWA',
    'BLR',
    'BLZ',
    'CAN',
    'CCK',
    'COD',
    'CAF',
    'COG',
    'CHE',
    'CIV',
    'COK',
    'CHL',
    // 'CUB',
    'CUW',
    'CMR',
    'CHN',
    'COL',
    'CRI',
    'CPV',
    'CXR',
    'CYP',
    'CZE',
    'DEU',
    'DJI',
    'DNK',
    'DMA',
    'DOM',
    'DZA',
    'ECU',
    'EST',
    'EGY',
    'ESH',
    'ERI',
    'ESP',
    'ETH',
    'FIN',
    'FJI',
    'FLK',
    'FSM',
    'FRO',
    'FRA',
    'GAB',
    'GBR',
    'GRD',
    'GEO',
    'GUF',
    'GGY',
    'GHA',
    'GIB',
    'GRL',
    'GMB',
    'GIN',
    'GLP',
    'GNQ',
    'GRC',
    'SGS',
    'GTM',
    'GUM',
    'GNB',
    'GUY',
    'HKG',
    'HMD',
    'HND',
    'HRV',
    'HTI',
    'HUN',
    'IDN',
    'IRL',
    // 'IRN',
    'ISR',
    'IMN',
    'IND',
    'IOT',
    'IRQ',
    'ISL',
    'ITA',
    'JEY',
    'JAM',
    'JOR',
    'JPN',
    'KEN',
    'KGZ',
    'KHM',
    'KIR',
    'COM',
    'KNA',
    'KOR',
    'KWT',
    'CYM',
    'KAZ',
    'LAO',
    'LBN',
    'LCA',
    'LIE',
    'LKA',
    'LBR',
    'LSO',
    'LTU',
    'LUX',
    'LVA',
    'LBY',
    'MAR',
    'MCO',
    'MDA',
    'MNE',
    'MDG',
    'MHL',
    'MKD',
    'MLI',
    'MMR',
    'MNG',
    '#N/',
    'MNP',
    'MTQ',
    'MRT',
    'MSR',
    'MLT',
    'MUS',
    'MDV',
    'MWI',
    'MEX',
    'MYS',
    'MOZ',
    'NAM',
    'NCL',
    'NER',
    'NFK',
    'NGA',
    'NIC',
    'NLD',
    'NOR',
    'NPL',
    'NRU',
    'NIU',
    'NZL',
    'OMN',
    'PAN',
    'PER',
    'PYF',
    'PNG',
    'PHL',
    'PAK',
    'POL',
    // 'PRK',
    'PSE',
    'SPM',
    'PCN',
    'PRI',
    'PRT',
    'PLW',
    'PRY',
    'QAT',
    'REU',
    'ROU',
    'SRB',
    'RUS',
    'RWA',
    'SAU',
    'SLB',
    'SYC',
    // 'SYR',
    'SWE',
    'SGP',
    'SHN',
    'SVN',
    'SJM',
    'SVK',
    'SLE',
    'SMR',
    'SEN',
    'SOM',
    'SUR',
    'STP',
    'SLV',
    'SWZ',
    'TCA',
    'TCD',
    'ATF',
    'TGO',
    'THA',
    'TJK',
    'TKL',
    'TLS',
    'TKM',
    'TUN',
    'TON',
    'TUR',
    'TTO',
    'TUV',
    'TWN',
    'TZA',
    'UKR',
    'UGA',
    'UMI',
    'USA',
    'URY',
    'UZB',
    'VAT',
    'VCT',
    'VEN',
    'VGB',
    'VIR',
    'VNM',
    'VUT',
    'WLF',
    'WSM',
    'YEM',
    'MYT',
    'ZAF',
    'ZMB',
    'ZWE',
    'BLM',
    'BES',
    'KOS',
    'MAC',
    'MAF',
    'SDN',
    'SXM',
];
//# sourceMappingURL=resources.js.map